module.exports = __webpack_public_path__ + "static/media/tiger.cb267002.png";